// import React from "react";
// import TTSIntentHead from "./TableHead/TTSIntentHead";
// import TTSIntentBody from "./TableBody/TTSIntentBody";

// const TTSIntentTable = ({
//   permissionsAccessControl,
//   ttsIntents,
//   handleDelete,
//   status,
// }) => {
//   return (
//     <div className="row" style={{ marginTop: "10px" }}>
//       <div className="col-12">
//         <div className="card">
//           <div className="card__body">
//             <div className="table-wrapper">
//               <table style={{ overflow: "hidden" }}>
//                 <TTSIntentHead
//                   permissionsAccessControl={permissionsAccessControl}
//                   status={status}
//                 />
//                 <TTSIntentBody
//                   ttsIntents={ttsIntents}
//                   handleDelete={handleDelete}
//                   status={status}
//                 />
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

import ReusableDataTable from "src/components/table/ReusableDataTable";
import { mapIntentToDataTable as mapData } from "./Helper";
import GetTTSIntentColumns from "./ColumnDefinition/TTSIntentColumn/GetTTSIntentColumns";

const TTSIntentTable = ({ data, handleDelete, status }) => {
  const columns = GetTTSIntentColumns({
    handleDelete,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default TTSIntentTable;
